import React from 'react';
import { Group, Circle, Rect } from 'react-konva';
import { ChairItem as ChairItemType, Position, Size } from '../../types';

interface ChairItemProps {
  id: string;
  item: ChairItemType;
  position: Position;
  size: Size;
  rotation: number;
  isSelected: boolean;
  onDragStart: (e: any) => void;
  onDragEnd: (e: any) => void;
  onClick: (e: any) => void;
  onRotate: (id: string, rotation: number) => void;
}

const ChairItem: React.FC<ChairItemProps> = ({
  id,
  position,
  size,
  rotation,
  isSelected,
  onDragStart,
  onDragEnd,
  onClick,
  onRotate,
  item
}) => {
  // Handle rotation with the rotation handle
  const handleRotateStart = (e: any) => {
    e.cancelBubble = true; // Prevent parent drag
  };
  
  const handleRotateMove = (e: any) => {
    e.cancelBubble = true; // Prevent parent drag
    
    // Calculate the center of the item
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    const groupPos = {
      x: position.x,
      y: position.y
    };
    
    // Calculate angle between center of item and current mouse position
    const angle = Math.atan2(
      pointerPos.y - groupPos.y,
      pointerPos.x - groupPos.x
    ) * 180 / Math.PI + 90;
    
    // Round to nearest 15 degrees for better usability
    const snappedAngle = Math.round(angle / 15) * 15;
    
    onRotate(id, snappedAngle);
  };

  return (
    <Group
      id={id}
      x={position.x}
      y={position.y}
      rotation={rotation}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      {/* Chair seat */}
      <Circle
        id={id}
        radius={Math.min(size.width, size.height) / 2}
        fill="#f0f0f0"
        stroke={isSelected ? "#3498db" : "#888"}
        strokeWidth={isSelected ? 2 : 1}
      />
      
      {/* Chair back */}
      <Rect
        id={id}
        x={-size.width / 8}
        y={-size.height / 2 - size.height / 4}
        width={size.width / 4}
        height={size.height / 4}
        fill="#e0e0e0"
        stroke={isSelected ? "#3498db" : "#888"}
        strokeWidth={isSelected ? 2 : 1}
        cornerRadius={2}
      />

      {/* Rotation Handle - only show when selected */}
      {isSelected && (
        <>
          {/* Rotation indicator line */}
          <Rect
            x={0}
            y={-size.height / 2 - 30}
            width={2}
            height={30}
            fill="#3498db"
            offsetX={1}
          />
          
          {/* Rotation handle */}
          <Circle
            x={0}
            y={-size.height / 2 - 40}
            radius={10}
            fill="#3498db"
            stroke="#fff"
            strokeWidth={2}
            draggable
            onDragStart={handleRotateStart}
            onDragMove={handleRotateMove}
            onMouseEnter={(e) => {
              const container = e.target.getStage()?.container();
              if (container) container.style.cursor = 'grab';
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage()?.container();
              if (container) container.style.cursor = 'default';
            }}
          />
        </>
      )}
    </Group>
  );
};

export default ChairItem; 